import { useNavigate } from "react-router";
import { useGetAllRetirementQuery } from "../../../../api/financeApi";
import { TableActions } from "../../../Components/Misc/Actions";
import Pagination from "../../../Components/Pagination/Pagination";
import Table from "../../../Components/Table/Table";
import { useEffect } from "react";
import { FormatDateTime } from "../../../../../utils/functions/ResourceFunctions";

export default function Retirement({
  startDate,
  endDate,
  pageSize,
  currentPage,
  searchText,
  filter,
  setCurrentPage,
  setPageSize,
  setRetirementLenght,
}) {
  const { data, isLoading } = useGetAllRetirementQuery({
    pageSize: pageSize,
    pageNumber: currentPage,
    searchText,
    filter,
    startDate,
    endDate,
  });
  console.log(data, "data");
  useEffect(() => {
    setRetirementLenght(data?.result?.length);
  }, [data]);
  const navigate = useNavigate();
  const handleView = (id) => {
    if (id) {
      navigate(`${id}/view-retirement`);
    }
  };
  const tableContent = isLoading ? (
    <tr>
      <td colSpan={6} className="text-center">
        Loading...
      </td>
    </tr>
  ) : data?.result?.length > 0 ? (
    data?.result?.map((item, index) => {
      return (
        <tr key={index}>
          <td>{index + 1}</td>
          <td>{item?.requester}</td>
          <td>
            {parseInt(item?.floatTypeName) === 1
              ? "Relationship Management"
              : "Business Development"}
          </td>
          <td>₦{item?.approvedAmount?.toLocaleString()}</td>
          <td>₦{item?.amountPayable?.toLocaleString()}</td>
          <td>{FormatDateTime(item?.retirementDate)}</td>
          <td>{item?.approvalStatusName}</td>
          <td>{FormatDateTime(item?.retirementDate)}</td>
          <td>{item?.approvalStatusName}</td>
          <td>
            <TableActions hasChildren={true} url={`${item.id}/view-retirement`}>
              {[
                {
                  name: "View",
                  action: () => handleView(item.id),
                },
              ]}
            </TableActions>
          </td>
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan={6} className="text-center">
        No Status Label Found
      </td>
    </tr>
  );
  return (
    <div className="overflow-x-scroll">
      <Table>
        <thead>
          <tr>
            <th>S/N</th>
            <th>Requestor Name</th>
            <th>Purpose</th>
            <th>Amount Advanced</th>
            <th>Payment Date</th>
            <th>Due Date</th>
            <th>Retirement Status</th>
            <th>Retirement Deadline</th>
            <th>Approval Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>{tableContent}</tbody>
      </Table>
      <Pagination
        currentPage={currentPage}
        pageSize={pageSize}
        totalCount={data?.responseObject?.totalCount}
        onPageChange={setCurrentPage}
        onPageSizeChange={setPageSize}
      />
    </div>
  );
}
